module.exports = __webpack_public_path__ + "static/images/dot-graph.91bc886ff77116895879031ffdea70b9.svg";